import { render, staticRenderFns } from "./Img.vue?vue&type=template&id=1ca2ae98&scoped=true&"
import script from "./Img.vue?vue&type=script&lang=js&"
export * from "./Img.vue?vue&type=script&lang=js&"
import style0 from "./Img.vue?vue&type=style&index=0&id=1ca2ae98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca2ae98",
  null
  
)

export default component.exports